module.exports = __webpack_public_path__ + "img/progress_009.ee665512.png";